import { ActivitiesPageFilters } from "domain/entities/activities.entities";
import { createAppAsyncThunk } from "domain/store.thunk";

export const getVisualSupports = createAppAsyncThunk(
  "visualSupports/getVisualSupports",
  async (
    filters: Partial<ActivitiesPageFilters> & Partial<{ search: string }>,
    { extra: { visualSupportsGateway } }
  ) => {
    return await visualSupportsGateway.getVisualSupports(filters);
  }
);

export const setIsVisualSupportLoading = createAppAsyncThunk(
  "visualSupports/setIsVisualSupportLoading",
  async (isLoading: boolean, { extra: { visualSupportsGateway } }) => {
    return { isLoading };
  }
);

export const getVisualSupport = createAppAsyncThunk(
  "visualSupports/getVisualSupport",
  async (id: number, { extra: { visualSupportsGateway } }) => {
    return await visualSupportsGateway.getVisualSupport(id);
  }
);

export const getFavoritesVisualSupports = createAppAsyncThunk(
  "visualSupports/getFavoritesVisualSupports",
  async (supportIds: number[], { extra: { visualSupportsGateway } }) => {
    return await visualSupportsGateway.getFavoritesVisualSupports(supportIds);
  }
);

export const getRandomVisualSupport = createAppAsyncThunk(
  "visualSupports/getRandomVisualSupport",
  async (_, { extra: { visualSupportsGateway } }) => {
    return await visualSupportsGateway.getRandomVisualSupport();
  }
);
